import { FormattedMessage } from "react-intl";
import "../styles/components.scss";

const DoctorTimeCard = ({
  imageSrc,
  title,
  timeSaved,
  timeSpent,
  netSavings,
  subTitle,
}) => {
  return (
    <div className="roi--card">
      <div className="roi--card-title">
        <span>{title}</span> <br /> {subTitle}
      </div>

      <img src={imageSrc} alt="Doctor" className="roi--image" />

      <div className="roi--label-dc-time">
        <FormattedMessage id="timeSavedInpractice" />
        <br /> (<FormattedMessage id="inPractice" />)
      </div>
      <div>
        <span className="roi--time-saved">{timeSaved} h</span>
        <span className="roi--per-year">
          /<FormattedMessage id="year" />
        </span>
      </div>
      {timeSpent ? (
        <>
          <div className="roi--net-icons">
            <img src="/images/icons/stop.svg" alt="stop" />
          </div>

          <div className="roi--label-dc-time">
            <FormattedMessage id="timeSpent" />
          </div>
          <div>
            <span className="roi--time-saved">{timeSpent} h</span>
            <span className="roi--per-year">
              /<FormattedMessage id="year" />
            </span>
          </div>
        </>
      ) : (
        <></>
      )}
      {netSavings ? (
        <>
          <div className="roi--net-icons">
            <img src="/images/icons/arrow-down.svg" alt="stop" />
          </div>

          <div className="roi--net-label">
            <FormattedMessage id="netSaving" />
          </div>
          <div className="roi--net-value">
            {netSavings} h
            <span>
              /
              <span style={{ fontSize: "20px" }}>
                <FormattedMessage id="year" />
              </span>
            </span>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default DoctorTimeCard;
